import { Component,ViewChild } from '@angular/core';
import { HomePage } from '../../home/home/home';
import { AboutHomePage } from '../../about/home/abouthome';
import { MessageListPage } from '../../message/list/list';
import { AppState } from '../../../app/app.global';
import { TripPage } from '../../trip/trip';
import {ServicehomePage} from '../../service/servicehome/servicehome';
import { NavController,AlertController, Navbar,App,Tabs, NavParams } from 'ionic-angular';
import { GestureLoginPage } from '../../login/gesturelogin/gesturelogin'
import { StorageService } from '../../../providers/service/storageservice';

export class Tab {
  title: string;
  component: any;
  tabBadge: any;
  tabBadgeStyle: any;
  tabIcon:any;
}
@Component({
  selector:'tabs-page',
  templateUrl: 'tabs.html'
})
export class TabsPage {
  tabs: Array<Tab> = TABS;
  
  home = HomePage;
  message = MessageListPage;
  trip = TripPage;
  about = AboutHomePage;
  service = ServicehomePage;

  constructor(public navCtrl: NavController,public global: AppState ,public appCtrl: App, public navParams: NavParams) {
    if(!StorageService.getObj("fromlogin")  //密码登录则不需要再次手势登录
      &&!StorageService.getObj("gesturepassed")//未进行手势验证
      &&StorageService.getObj("showGesture")
      &&StorageService.getObj("gesture")) {
      this.appCtrl.getRootNav().setRoot(GestureLoginPage);
    }
    StorageService.setObj("fromlogin",false);//下次打开app或刷新页面，不是通过登录页密码验证的，需要重新手势验证
    StorageService.setObj("gesturepassed",false);//下次打开app或刷新页面，需要重新手势验证
  }

}

const TABS  =[
  {"id":1,"title":"首页",component:HomePage,tabBadge:"",tabBadgeStyle:"",tabIcon:"home"},
  {"id":2,"title":"服务",component:ServicehomePage,tabBadge:"",tabBadgeStyle:"danger",tabIcon:"apps"},
  {"id":3,"title":"消息",component:MessageListPage,tabBadge:"",tabBadgeStyle:"danger",tabIcon:"ios-text"},
  {"id":4,"title":"我",component:AboutHomePage,tabBadge:"",tabBadgeStyle:"",tabIcon:"person"},
];






// WEBPACK FOOTER //
// ./src/pages/tabs/tabs/tabs.ts